<template>
  <b-modal id="referral-modal-detail" ref="modal" size="lg" title="Detail" @show="setData" @hidden="resetModal">
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Name</label>
                <div class="col-md-8 mb-3">
                  {{detail.name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Referral Type</label>
                <div class="col-md-8 mb-3">
                  {{detail.type_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Street</label>
                <div class="col-md-8 mb-3">
                  {{detail.street}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Country</label>
                <div class="col-md-8 mb-3">
                  {{detail.country_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">State</label>
                <div class="col-md-8 mb-3">
                  {{detail.state_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">City</label>
                <div class="col-md-8 mb-3">
                  {{detail.city_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Postal Code</label>
                <div class="col-md-8 mb-3">
                  {{detail.postal_code}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Phone</label>
                <div class="col-md-8 mb-3">
                  {{detail.phone_number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Mobile</label>
                <div class="col-md-8 mb-3">
                  {{detail.mobile}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Email</label>
                <div class="col-md-8 mb-3">
                  {{detail.email}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  {{detail.desc}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  {{detail.status == 1 ? "Active": "Not Active"}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Default</label>
                <div class="col-md-8 mb-3">
                  {{detail.is_default == 1 ? "Yes":"No"}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Last Modified</label>
                <div class="col-md-8 mb-3">
                  {{detail.last_modified}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from 'bootstrap-vue'
export default {
  name: "ReferralDetailForm",
  components:{
    BModal,
    BForm
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      detail:{
        name:"",
        type_name:"",
        street:"",
        country_name:"",
        state_name:"",
        city_name:"",
        postal_code:"",
        phone_number:"",
        mobile:"",
        email:"",
        desc:"",
        status:"",
        is_default:"",
        last_modified:""
      }
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if(this.data !== null){
          this.detail = this.data
        }
      }, 100)
    },
    resetModal(){
      this.$parent.data = null
      this.detail = {}
      this.$refs.modal.hide()
    }
  }
}
</script>